import axios from "axios";

export const fetchGetUsersForDropdown = async (parentCompanyId?: string) => {
  const query = parentCompanyId ? `&parentCompanyId=${parentCompanyId}` : "";
  return await axios.get(`/api/user?pageSize=-1${query}`);
};
